module.exports = __webpack_public_path__ + "static/dictionary20202-e9c03673e126b6a8d90a34ac1eb4dda8.png";